import { ButtonGroup, Flex, IconButton, IconCheckmark, IconClose } from '@zillow/constellation';
import React from 'react';

interface IEditFieldControlsProps {
  fieldName: string;
  submitOnChange?: boolean;
  cancel?: () => void;
  children: React.ReactNode;
}

export const EditFieldControls: React.FC<IEditFieldControlsProps> = ({
  fieldName,
  submitOnChange,
  cancel,
  children,
}) => {
  return (
    <Flex display={'flex'} alignItems={'center'} gap={1} flexGrow={1}>
      {children}
      <ButtonGroup conjoined aria-label={`${fieldName} Edit Controls`}>
        {submitOnChange && (
          <IconButton
            type={'submit'}
            buttonType={'primary'}
            icon={<IconCheckmark />}
            title={`Set ${fieldName}`}
            size={'sm'}
            data-test-id={`submit-edit-${fieldName}`}
          />
        )}
        {cancel && (
          <IconButton
            type={'button'}
            buttonType={'caution'}
            icon={<IconClose />}
            title={'Cancel'}
            size={'sm'}
            onClick={cancel}
            data-test-id={`${fieldName}-cancel`}
          />
        )}
      </ButtonGroup>
    </Flex>
  );
};
